import React, { Component } from 'react';
import LoadableComponent from '../../common-components/PlaceholderLoading/LoadableComponent';
import ContentLoadPlaceholder from '../../common-components/PlaceholderLoading/Templates/Content/ContentLoadPlaceholder';
import ContentLoadErrorPlaceholder from '../../common-components/PlaceholderLoading/Templates/Content/ContentLoadErrorPlaceholder';
import { Translation } from "react-i18next";
import { LoadScript } from '../../types/LoadScript';
import { Configuration } from '../../types/Configuration';
import { ApiErrorEvent, ErrorEventType } from '../../common-components/Notifications/Events';

type Props = {
    configuration: Configuration
    accessToken: string,
    selectedLanguage: string,
    onLoadCallback: () => void,
    onErrorCallback: () => void,
    tokenIsProvided: boolean,
    companyId: string
}

type State = {
    scriptsToBeLoaded: [LoadScript, LoadScript]
    loadableComponent: any
    hasApiError: boolean;
}

class ManagePeople extends Component<Props, State> {
    loadableComponentRef: React.RefObject<any>;
    constructor(props: Props) {
        super(props);
        this.state = {
            scriptsToBeLoaded: [ {} as LoadScript, {} as LoadScript ],
            loadableComponent: null,
            hasApiError: false
        };
        this.loadableComponentRef = React.createRef();
    }

    componentDidMount(){
        this.setState({
            scriptsToBeLoaded: [
                { url: `${this.props.configuration.peopleTileBaseUrl}/build/people-tile.esm.js`, type: "module", nomodule: false },
                { url: `${this.props.configuration.peopleTileBaseUrl}/build/people-tile.js`, type: "text/javascript", nomodule: true }
            ]
        })
        
        this._setEventListeners()
    }

    componentDidUpdate(prevProps: Props) {
        if (
            prevProps.configuration
            && this.props.configuration
            && prevProps.configuration.peopleTileBaseUrl  !== this.props.configuration.peopleTileBaseUrl 
        ) {
            this.setState({
                scriptsToBeLoaded: [
                    { url: `${this.props.configuration.peopleTileBaseUrl }/build/people-tile.esm.js`, type: "module", nomodule: false },
                    { url: `${this.props.configuration.peopleTileBaseUrl }/build/people-tile.js`, type: "text/javascript", nomodule: true }
                ]
            })
        }
    }

    _setEventListeners() {
        document.addEventListener('apiErrorEvent', ((event: CustomEvent<ApiErrorEvent>) => {
            if (event.detail.errorType === ErrorEventType.FatalError && event.detail.webComponentName === 'people-tile') {
                this.setState({hasApiError: true})
                this.loadableComponentRef.current.handleOutsideApiError();
            }
        }) as EventListener);
    }

    render() {
        const message = <Translation>{t => t(`Unfortunately we could not load "People".`)}</Translation>;
        const managePeopleUrl = `${this.props.configuration.managePeopleBaseUrl}/manage-people/${this.props.companyId}?culture=${this.props.selectedLanguage}`;

        return (
            <LoadableComponent
                loadPlaceholder={ContentLoadPlaceholder}
                errorPlaceholder={ContentLoadErrorPlaceholder}
                scriptsToBeLoaded={this.state.scriptsToBeLoaded}
                message={message}
                ref={this.loadableComponentRef}
                {... this.props}>
                <people-tile
                    token-is-provided={this.props.tokenIsProvided}
                    base-url={this.props.configuration.companyRelationsUserApiBaseUrl}
                    language={this.props.selectedLanguage}
                    company-id={this.props.companyId}
                    manage-people-url={managePeopleUrl}>
                </people-tile>
            </LoadableComponent>
        )
    }
}

export default ManagePeople;